module.exports = __webpack_public_path__ + "img/AC_S1_Final.1ed83558.jpg";